'use client';
import Image from "next/image";
import { useTranslation } from "react-i18next";

const BENEFITS = [
  { key: "benefit_1", icon: "/assets/CTA_2/icon-no-card.svg" },
  { key: "benefit_2", icon: "/assets/CTA_2/icon-no-cancellation.svg" },
  { key: "benefit_3", icon: "/assets/CTA_2/icon-no-charges.svg" },
];

const CTA_2 = () => {
  const { t } = useTranslation(['home']);

  return (
    <div className="cta2-section" data-home-reveal>
      <div className="cta2-media">
        <Image
          src="/assets/CTA_2/display-lifestyle.webp"
          alt="AdCast running on a TV mounted in a restaurant"
          fill
          className="cta2-media-image"
          sizes="(max-width: 767px) 0px, 46vw"
        />
      </div>

      <div className="container">
        <div className="cta2-grid">
          <div className="cta2-copy">
            <h2 className="cta2-headline">
              <span className="cta2-headline-dark">{t('cta2.headline_dark')}</span>
              <span className="cta2-headline-accent">{t('cta2.headline_accent')}</span>
            </h2>
            <p className="cta2-description">{t('cta2.description')}</p>

            <div className="cta2-benefits">
              {BENEFITS.map(({ key, icon }) => (
                <div className="cta2-benefit" key={key}>
                  <Image src={icon} alt="" width={48} height={48} className="cta2-benefit-icon" aria-hidden="true" />
                  <p>{t(`cta2.${key}`)}</p>
                </div>
              ))}
            </div>

            <p className="cta2-note">{t('cta2.note')}</p>

            <a
              className="cta2-primary"
              href="https://workspace.adcast.app/auth/signup"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('cta2.cta_label')} <span aria-hidden="true">→</span>
            </a>

            <p className="cta2-subnote">{t('cta2.subnote')}</p>
          </div>

          <div className="cta2-media-spacer" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default CTA_2;
